<template>
  <div id='game'>
    <GameList></GameList>
  </div>
</template>
<script>
import GameList from '../components/game/GameContent'
export default {
  name: 'game',
  components: {
    GameList,
  },
}
</script>
<style scoped>
#game {
  max-width: 1920px;
  margin-top: -80px;
}
</style>



// WEBPACK FOOTER //
// src/page/Game.vue